import { Controller } from "@hotwired/stimulus"

// Truncates a section description to one line and reveals a "more" link that opens the full text in
// a modal. On connect, hides the "more" link when the text isn't actually truncated (fits on one
// line). The modal itself is the shared modal component (its own `modal` controller handles close);
// this controller just opens it by id.
export default class extends Controller {
  static targets = ["text", "more"]
  static values = { modalId: String }

  connect() {
    if (!this.hasTextTarget || !this.hasMoreTarget) return
    const el = this.textTarget
    // line-clamp-1 caps clientHeight at one line; a taller scrollHeight means it's truncated.
    if (el.scrollHeight <= el.clientHeight + 1) {
      this.moreTarget.classList.add("hidden")
    }
  }

  open(event) {
    event.preventDefault()
    const modal = document.getElementById(this.modalIdValue)
    if (modal) modal.classList.remove("hidden")
  }
}
